import { FormikErrors } from 'formik';
import { IBillingFormProps } from './interfaces';

export const validateBillingForm = (values: IBillingFormProps, sameAsShipping: boolean) => {
  const errors: FormikErrors<IBillingFormProps> = {};
  if (!values.country) {
    errors.country = 'Please select a country';
  }
  if (!values.region) {
    errors.region = 'Please select a region';
  }
  if (!values.email || !values.email.includes('@') || values.email.length < 3) {
    errors.email = 'Please enter a valid email address';
  }
  if (!values.firstName) {
    errors.firstName = 'Please enter your first name';
  }
  if (!values.lastName) {
    errors.lastName = 'Please enter your last name';
  }
  if (!values.postCode) {
    errors.postCode = 'Please enter a valid post code';
  }
  if (!values.company) {
    errors.company = 'Please enter your company name';
  }
  if (!values.townCity) {
    errors.townCity = 'Please enter your town or city';
  }
  if (!values.address1) {
    errors.address1 = 'Please enter a valid address';
  }
  if (!values.phone) {
    errors.phone = 'Please enter a valid phone number';
  }

  if (!sameAsShipping) {
    if (!values.regionShipping) {
        errors.regionShipping = 'Please select a region';
      }
    if (!values.countryShipping) {
      errors.countryShipping = 'Please select a country';
    }
    if (!values.firstNameShipping) {
      errors.firstNameShipping = 'Please enter your first name';
    }
    if (!values.lastNameShipping) {
      errors.lastNameShipping = 'Please enter your last name';
    }
    if (!values.postCodeShipping) {
      errors.postCodeShipping = 'Please enter a valid post code';
    }
    if (!values.companyShipping) {
      errors.companyShipping = 'Please enter your company name';
    }
    if (!values.townCityShipping) {
      errors.townCityShipping = 'Please enter a town or city';
    }
    if (!values.phoneShipping) {
      errors.phoneShipping = 'Please enter a valid phone number';
    }
    if (!values.address1Shipping) {
      errors.address1Shipping = 'Please enter a valid address';
    }
  }
  return errors;
};
